/**
 * Compile an uploaded design system in a worker (see compileWorker). React's
 * export names come from the editor's React — the same one the sandbox
 * bundles — so the shims export exactly what the sandbox provides.
 */
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactDom from "react-dom";

import type { CompileResult } from "./compile.js";

export function compileInWorker(
  code: string,
  css: string,
): Promise<CompileResult> {
  const worker = new Worker(new URL("./compileWorker.ts", import.meta.url), {
    type: "module",
  });
  return new Promise<CompileResult>((resolve) => {
    worker.onmessage = (e: MessageEvent<CompileResult>) => resolve(e.data);
    worker.onerror = (e) =>
      resolve({ ok: false, errors: [e.message || "the compiler crashed"] });
    worker.postMessage({
      code,
      css,
      exportNames: {
        react: Object.keys(React),
        jsxRuntime: Object.keys(JsxRuntime),
        reactDom: Object.keys(ReactDom),
      },
    });
  }).finally(() => worker.terminate());
}
